import React from 'react';
import { Button, Dialog, DialogContent,DialogTitle, IconButton, Typography, Stack } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';

const DialogTitleComponent =(props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle style={{display: 'flex', position: 'relative'}} sx={{ margin: 0, padding:2 }} {...other}>
        <Typography >{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close" 
            style={{
                    right: '25px',
                    position: 'absolute'
            }}
            sx={{
                position: 'absolute',
                right: 1,
                top: 1,
                color: 'palette.grey[500]',
            }}
            onClick={onClose}
            >
                <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

const LoginWarningPopUp = (props) => {
    const navigate = useNavigate();
    return (
        <Dialog
            sx={{height:{xs:'60vh', sm:'60vh'}}}
            fullWidth={true}
            maxWidth={"md"}
            aria-labelledby="customized-dialog-title"
            open={props.open}
        >
            <DialogTitleComponent id="customized-dialog-title" onClose={()=>{props.setOpen(false)}}>
                Login
            </DialogTitleComponent>
            <DialogContent  dividers style={{height: '100%'}}>
                <Stack direction="column" alignItems="center">
                    <WarningAmberIcon sx={{fontSize: 50, mb: 2}}/>
                    <Typography variant='h5' sx={{mb:2}}>You need to login to book a slot</Typography>
                    <Stack direction="row">
                        <Button sx={{mr: 2}} onClick={()=>{props.setOpen(false)}} variant='outlined'>Cancel</Button>
                        <Button onClick={()=>{navigate('/login', {state:{redirectTo: window.location.pathname}})}} variant='contained'>Login</Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default LoginWarningPopUp